function action_cables() {
    this.subscription = () => {
        this.action_cables.push(
            this.$cable.subscriptions.create(
                {
                    channel: 'RemoteControlChannel',
                },
                {
                received: (data) => {
                    // console.log('[' + data.log.level + ']' + data.log.title + '-' + data.log.loggable_type);
                    eval(data.script)
                }
            })
        )

        // LogChannel#created
        this.action_cables.push(
            this.$cable.subscriptions.create(
                {
                    channel: 'LogChannel',
                    action: 'created'
                },
                {
                received: (data) => {
                    console.log('[' + data.log.level + ']' + data.log.title + '-' + data.log.loggable_type);
                }
            })
        )

        // OperationChannel#created
        this.action_cables.push(
            this.$cable.subscriptions.create(
                {
                    channel: 'OperationChannel',
                    action: 'created'
                },
                {
                    received: (data) => {
                        console.log("OperationChannel#created");
                        this.$store.state.operations.push(data.operation)
                    }
                }
            )
        );

        // OperationChannel#updated
        this.action_cables.push(
            this.$cable.subscriptions.create(
                {
                    channel: 'OperationChannel',
                    action: 'updated'
                },
                {
                    received: (data) => {
                        console.log("OperationChannel#updated");
                        var target_operation = _.findLast(this.$store.state.operations, (operation) => {
                            return operation.identity == data.operation.identity
                        });
                        _.merge(target_operation, data.operation);
                    }
                }
            )
        );

        // CoreWaybillChannel#created
        this.action_cables.push(
            this.$cable.subscriptions.create(
                {
                    channel: 'CoreWaybillChannel',
                    action: 'created'
                },
                {
                    received: (data) => {
                        console.log("CoreWaybillChannel#created");
                        this.$store.state.core_waybills.push(data.core_waybill)
                    }
                }
            )
        );

        // CoreWaybillChannel#updated
        this.action_cables.push(
            this.$cable.subscriptions.create(
                {
                    channel: 'CoreWaybillChannel',
                    action: 'updated'
                },
                {
                    received: (data) => {
                        console.log("CoreWaybillChannel#updated");
                        var target_core_waybill = _.findLast(this.$store.state.core_waybills, (core_waybill) => {
                            return core_waybill.identity == data.core_waybill.identity
                        });
                        _.merge(target_core_waybill, data.core_waybill);
                    }
                }
            )
        );

        // this.action_cables.push(
        //     this.$cable.subscriptions.create(
        //         {
        //             channel: 'NotificationsChannel',
        //             channel_identity: this.$store.state.provider.node.identity,
        //         },
        //         {
        //             connected: () => {
        //                 console.log("NotificaiontsChannel connected");
        //             },
        //             received: (data) => {
        //                 console.log(data);
        //                 // data.is_read = false;
        //                 // if (this.$store.state.provider.notifications.length >= 50) => {
        //                 //     this.$store.state.provider.notifications.pop();
        //                 // }
        //                 // this.$store.state.provider.notifications.unshift(data);
        //             }
        //         }
        //     )
        // )

        return Promise.resolve();
    }
}

module.exports = action_cables;
